import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SignUpHandler from '../Apihander/signup/signupHandler';
import SidebarContext from '../contexts/MyContext';

export const usePremiumStatus = () => {
  const navigate = useNavigate();
  const { premiumStatus, setPremiumStatus, premiumStatusLoading, setPremiumStatusLoading, isPolling, setIsPolling, isSubscriptionActive, setIsSubscriptionActive } = useContext(SidebarContext)


  const checkPremiumStatus = async () => {
    // setPremiumStatusLoading(true)
    try {
      const data = await SignUpHandler.doGetSubscriptionStatus();

      if (data?.status !== undefined) {

        if (data?.status !== premiumStatus?.status || premiumStatus == null) {
          setPremiumStatus(data);
        }
      }
      // setPremiumStatus(data);
      setPremiumStatusLoading(false)
      if (data?.response?.data?.status === 'INTIATED_IN_PROGRESS' || data?.status === 'INTIATED_IN_PROGRESS') {
        setIsPolling(true);
      } else {
        setIsPolling(false);
        if (data?.status === "SUCCESS") {
          const storedUser = JSON.parse(localStorage.getItem("currentUser"));
          if (storedUser) {
            const updatedUser = { ...storedUser, isSubscriptionActive: true };
            localStorage.setItem("currentUser", JSON.stringify(updatedUser));
            setIsSubscriptionActive(true); 

          }
        }

      }
    } catch (error) {
      console.error('Error checking premium status:', error);
      setIsPolling(false);
      setPremiumStatusLoading(false)
    }
  };


  const startPolling = () => {
    checkPremiumStatus();
    // setIsPolling(true);
  };


  useEffect(() => {
    let pollingInterval;
    // console.log(isPolling, "polling interval");

    if (isPolling) {
      pollingInterval = setInterval(checkPremiumStatus, 15000);
    }
    return () => clearInterval(pollingInterval);
  }, [isPolling]);

  // Load subscription status from localStorage on component mount
  // useEffect(() => {
  //   const storedUser = JSON.parse(localStorage.getItem("currentUser"));
  //   if (storedUser?.isSubscriptionActive) {
  //     setIsSubscriptionActive(true);
  //   }
  // }, [isSubscriptionActive]);

  // useEffect(() => {
  //   checkPremiumStatus();

  //   const handleFocusOrVisibilityChange = () => {
  //     checkPremiumStatus();
  //   };


  //   document.addEventListener('visibilitychange', () => {
  //     if (document.visibilityState === 'visible') {
  //       handleFocusOrVisibilityChange();
  //     }
  //   });

  //   return () => {
  //     document.removeEventListener('visibilitychange', handleFocusOrVisibilityChange);
  //   };
  // }, []);

  return { premiumStatus, premiumStatusLoading, startPolling };

};
